import { Component, OnInit } from '@angular/core';
import { AngularFirestoreCollection, AngularFirestore, Query } from '@angular/fire/firestore';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-solicitudes-nip',
  templateUrl: './solicitudes-nip.component.html',
  styleUrls: ['./solicitudes-nip.component.scss']
})
export class SolicitudesNipComponent implements OnInit {

  private tropasCol: AngularFirestoreCollection<any>;
  public  tropas:    Observable<any>;
  public tropasMap: Map<String,any> = new Map<String,any>();

  private solicitudesCol: AngularFirestoreCollection<any>;
  private solicitudes: Observable<any>;

  public  allItems: any[];

  public tropa:string = "";  

  public displayedColumns = [
    "solicita", 
    "nroTelefono", 
    "solicitaFecha", 
    "respuesta",
  ];


  constructor(private afFirestore: AngularFirestore, ){ 

  }  

  ngOnInit() {
    this.solicitudesCol   = this.afFirestore.collection<any>("solicitud-nip", ref => ref.orderBy("solicitaFecha", "desc") );
    this.solicitudes      = this.solicitudesCol.snapshotChanges();
    this.tropasCol         = this.afFirestore.collection<any>("tropa");
    this.tropas            = this.tropasCol.valueChanges();
    this.tropas.subscribe(
      (lastTropas)=>{
        lastTropas.forEach(
          (tropa)=>{            
            this.tropasMap.set(tropa.uid, tropa);
          }
        );        
      }
    );    
  }

  private suscription = null;

  public isLoading:boolean = true;  

  ngAfterViewInit(){ 
    this.isLoading = true;
    if( this.suscription != null ){
      this.suscription.unsubscribe();
    }   
    this.suscription = this.solicitudes
      .subscribe(
        lastVals => {                                        
          this.allItems = lastVals.map(
            (solicitud:any)=>{              
              const uid = solicitud.payload.doc.id;              
              return {
                uid,
                ...solicitud.payload.doc.data()
              };
            }
          );          
          this.isLoading = false;          
        }
      );
  }

  trackByUid(index, item) {
    return item.uid;
  }

  applyFilter() {       
    this.isLoading = true;   
    this.solicitudesCol = this.afFirestore.collection<any>(
      "solicitud-nip", 
      ref => {
        let ref2:Query = ref;
        if( this.tropa !== "" ){
          ref2 = ref2.where("reportaCedula", "==", this.tropa);          
        }        
        return ref2.orderBy("solicitaFecha", "desc");

      } 
    );        
    this.solicitudes = this.solicitudesCol.snapshotChanges();
    this.ngAfterViewInit();    
  }  

}
